export const listOfficeDoggos = (client) => client.rpcNoAuth('service-doggos', '1/2019-06-24/list_office_doggos', void 0);
